import { Button, ClickAwayListener, Typography } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded'
import HealthAndSafetyRoundedIcon from '@mui/icons-material/HealthAndSafetyRounded'
import CopyAllRoundedIcon from '@mui/icons-material/CopyAllRounded'
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded'
import KeyRoundedIcon from '@mui/icons-material/KeyRounded'
import LocationOnRoundedIcon from '@mui/icons-material/LocationOnRounded'
import LocalPhoneRoundedIcon from '@mui/icons-material/LocalPhoneRounded'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded'
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded'
import clsx from 'clsx'
import { useGetIdsHealthcareservicesHcsIdConsultations } from '@toktokdoctech/tokapi-client'
import useCurrentUser from '../../hooks/useCurrentUser'
import useStyles from './_styles'
import { ConsultationIcon } from '../../assets/icons/icons'
import { useButtonsStyles } from '../../styles'
import { displaySnackbar } from '../../actions/main'
import { useAppDispatch } from '../../store'
import useCurrentHcs from '../../hooks/useCurrentHcs'
import useUserPermissions from '../../hooks/useUserPermissions'

const TopBanner = () => {
    const classes = useStyles()
    const buttonClasses = useButtonsStyles()
    const currentHcs = useCurrentHcs()
    const currentUser = useCurrentUser()
    const { hasUserPermission } = useUserPermissions()
    const [infoOpen, setInfoOpen] = React.useState(null)
    const topBannerHcsButtonRef = React.createRef()
    const dispatch = useAppDispatch()

    const { data: consultations } = useGetIdsHealthcareservicesHcsIdConsultations(
        currentHcs.id,
        {
            limit: 1,
        },
        {
            query: {
                enabled: currentHcs.isConsultationEnabled ?? false,
                queryKey: ['consultations', currentHcs.id],
            },
        },
    )
    const consultationsLength = consultations?.total ?? 0

    const copyCodeToClipboard = async () => {
        navigator.clipboard.writeText(currentHcs.securityCode).then(
            () => {
                dispatch(displaySnackbar('success', 'Code de sécurité copié'))
            },
            () => {
                dispatch(displaySnackbar('error', 'Impossible de copier le code de sécurité'))
            },
        )
    }

    const consultationLengthLabel = `${consultationsLength === 1 ? 'téléconsultation' : 'téléconsultations'} à venir`

    const renderButton = () => (
        <div className={clsx(classes.TopBannerButtonHolder, infoOpen && classes.TopBannerButtonHolderOpen)}>
            {/* @ts-expect-error TS(2769) FIXME: No overload matches this call. */}
            <Button
                className={classes.TopBannerHcsButton}
                disableElevation
                onClick={() => {
                    // @ts-expect-error TS(2345) FIXME: Argument of type 'true' is not assignable to param... Remove this comment to see the full error message
                    if (!infoOpen) setInfoOpen(true)
                }}
                ref={topBannerHcsButtonRef}
                data-cy="topBannerContainer_infoTrigger"
            >
                <div className={classes.TopBannerHcsButtonLeft}>
                    <HomeRoundedIcon />
                    <div className={classes.TopBannerHcsButtonLeftText}>
                        <Typography className={classes.TopBannerHcsButtonLeftName}>{currentHcs.name}</Typography>
                        <Typography className={classes.TopBannerHcsButtonLeftCode}>
                            <span>(</span>
                            <KeyRoundedIcon />
                            <span>{currentHcs.securityCode}</span>
                            <span>)</span>
                        </Typography>
                    </div>
                </div>
                <div className={classes.TopBannerHcsButtonSeparator} />
                <div className={classes.TopBannerHcsButtonRight}>
                    <span>Voir les informations</span>
                    {infoOpen ? <ArrowDropUpRoundedIcon /> : <ArrowDropDownRoundedIcon />}
                </div>
            </Button>
            {infoOpen && (
                <ClickAwayListener
                    onClickAway={() => {
                        if (infoOpen) {
                            // @ts-expect-error TS(2345) FIXME: Argument of type 'false' is not assignable to para... Remove this comment to see the full error message
                            setInfoOpen(false)
                        }
                    }}
                >
                    <div className={classes.TopBannerButtonInfos} data-cy="topBannerContainer_content">
                        <div className={classes.TopBannerButtonInfosSeparator} />
                        <div className={classes.TopBannerButtonInfosContent}>
                            <div className={classes.TopBannerPopoverContentItems}>
                                <div className={classes.TopBannerPopoverContentItemsItem}>
                                    <Typography className={classes.TopBannerPopoverContentItemsItemTitle}>
                                        Adresse
                                    </Typography>
                                    <Typography
                                        className={classes.TopBannerPopoverContentItem}
                                        data-cy="topBannerContainer_address"
                                    >
                                        <LocationOnRoundedIcon />
                                        <span>{`${currentHcs.address.street}, ${currentHcs.address.postalCode} - ${currentHcs.address.city}`}</span>
                                    </Typography>
                                </div>
                                <div className={classes.TopBannerPopoverContentItemsItem}>
                                    <Typography className={classes.TopBannerPopoverContentItemsItemTitle}>
                                        Téléphone
                                    </Typography>
                                    <Typography
                                        className={classes.TopBannerPopoverContentItem}
                                        data-cy="topBannerContainer_phone"
                                    >
                                        <LocalPhoneRoundedIcon />
                                        <span>{currentHcs.phone}</span>
                                    </Typography>
                                </div>
                                <div className={classes.TopBannerPopoverContentItemsItem}>
                                    <Typography className={classes.TopBannerPopoverContentItemsItemTitle}>
                                        Code de sécurité
                                    </Typography>
                                    <Typography
                                        className={classes.TopBannerPopoverContentItem}
                                        data-cy="topBannerContainer_securityCode"
                                    >
                                        <KeyRoundedIcon />
                                        <span>{currentHcs.securityCode}</span>
                                        <CopyAllRoundedIcon
                                            className={classes.TopBannerPopoverContentItemInnerIcon}
                                            onClick={copyCodeToClipboard}
                                        />
                                    </Typography>
                                </div>
                            </div>
                            {hasUserPermission('ADMIN') && (
                                <div className={classes.TopBannerPopoverContentActions}>
                                    <div className={classes.TopBannerPopoverContentItemsItem}>
                                        <Typography className={classes.TopBannerPopoverContentItemsItemTitle}>
                                            Établissement
                                        </Typography>
                                        <div
                                            className={clsx(
                                                classes.TopBannerPopoverContentItem,
                                                classes.TopBannerPopoverContentActionsButtons,
                                            )}
                                        >
                                            <Button
                                                className={buttonClasses.ButtonTextPrimary}
                                                color="inherit"
                                                disableElevation
                                                component={Link}
                                                to="/establishment"
                                                data-cy="hcsEdit"
                                                startIcon={<SettingsSuggestRoundedIcon />}
                                            >
                                                Gérer l'établissement
                                            </Button>
                                            <Button
                                                className={buttonClasses.ButtonTextPrimary}
                                                color="inherit"
                                                component={Link}
                                                to="/preferences"
                                                data-cy="hcsSettings"
                                                startIcon={<HealthAndSafetyRoundedIcon />}
                                            >
                                                Modifier les préférences
                                            </Button>
                                            <Button
                                                className={buttonClasses.ButtonTextPrimary}
                                                color="inherit"
                                                component={Link}
                                                to="/users"
                                                data-cy="hcsUsers"
                                                startIcon={<PeopleAltRoundedIcon />}
                                            >
                                                Gérer les utilisateurs
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </ClickAwayListener>
            )}
        </div>
    )

    return (
        <div className={classes.TopBanner} data-cy="topBannerContainer">
            <div className={classes.TopBannerWelcome}>
                <Typography className={classes.TopBannerWelcomeText}>{`Bonjour ${currentUser.fullName}`}</Typography>
                <Typography className={classes.TopBannerWelcomeSubtext}>
                    Bienvenue sur votre espace établissement
                </Typography>
            </div>
            <div className={classes.TopBannerBottom}>
                {infoOpen && <div className={classes.TopBannerHcsButtonAbsoluteSpacer} />}
                {renderButton()}
                {consultationsLength > 0 && (
                    <Button
                        component={Link}
                        to="/planned-consultations"
                        className={classes.TopBannerNotificationButton}
                    >
                        <div className={classes.TopBannerNotificationButtonIcon}>
                            <ConsultationIcon className={classes.TopBannerNotificationButtonIconIcon} />
                        </div>
                        <Typography
                            className={classes.TopBannerNotificationButtonText}
                        >{`${consultationsLength} ${consultationLengthLabel}`}</Typography>
                    </Button>
                )}
            </div>
        </div>
    )
}

export default TopBanner
